import { motion } from 'framer-motion';
import SectionWrapper from '../ui/SectionWrapper';
import TechIcon from '../ui/TechIcon';
import { technologies } from '../../data/technologies';

const Skills = () => {
    const categoryVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] },
        },
    };

    return (
        <SectionWrapper id="skills">
            <motion.h2
                className="text-3xl md:text-4xl font-heading font-bold mb-12 text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <span className="text-gradient">Technologies</span>
            </motion.h2>

            <div className="space-y-12">
                {Object.entries(technologies).map(([key, category], categoryIndex) => (
                    <motion.div
                        key={key}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={categoryVariants}
                        transition={{ delay: categoryIndex * 0.1 }}
                    >
                        <h3 className="text-xl md:text-2xl font-heading font-semibold mb-6 text-text-primary">
                            {category.title}
                        </h3>

                        <div className="flex flex-wrap gap-4">
                            {category.items.map((tech, index) => (
                                <TechIcon
                                    key={tech.name}
                                    icon={tech.icon}
                                    name={tech.name}
                                    color={tech.color}
                                    delay={index * 0.05}
                                />
                            ))}
                        </div>
                    </motion.div>
                ))}
            </div>
        </SectionWrapper>
    );
};

export default Skills;
